import { Dimensions, PixelRatio } from "react-native";

const dimensions = Dimensions.get('window');

function getOrientation() {
  return (dimensions.width < dimensions.height) ? 'portrait' : 'landscape'
}

export function getFontSizeByWindowWidth(fontSize: number) {

  const baseWidth = 375; // width of smallest iPhone
  const width = (getOrientation() == 'portrait') ? dimensions.width : dimensions.height
  return PixelRatio.roundToNearestPixel(fontSize * (width / baseWidth));
}

export function getFontSizeByWindowHeight(fontSize: number) {

  const baseHeight = 812; // width of smallest iPhone
  const height = (getOrientation() == 'portrait') ? dimensions.height : dimensions.width
  return PixelRatio.roundToNearestPixel(fontSize * (height / baseHeight));
}